/**
 * The API's origin, e.g. https://wonderherbals.vercel.app.
 *
 * VITE_API_URL may be given with or without a trailing "/api"; both are
 * accepted so every caller can append "/api/..." itself. Without it,
 * development uses the local API and production uses the deployed one —
 * never a developer's localhost.
 */
const PRODUCTION_API = 'https://wonderherbals.vercel.app';

const raw = (import.meta.env.VITE_API_URL || (import.meta.env.DEV ? 'http://localhost:4001' : PRODUCTION_API)).trim();

export const API_ORIGIN = raw.replace(/\/+$/, '').replace(/\/api$/, '');

/** Base for the generic `useApi` helpers, whose endpoints omit the /api prefix. */
export const API_PREFIX = `${API_ORIGIN}/api`;
